import gql from 'graphql-tag';

export const DetailsPanelContentCreatedDateQuery = gql`
	query DetailsPanelContentCreatedDateQuery($contentId: ID!, $status: String!) {
		content(id: $contentId, status: [$status]) {
			nodes {
				id
				metadata {
					createdDate
				}
			}
		}
	}
`;
